/**
 * Calculates in percent, the change between 2 numbers.
 * 
 * @param oldNumber The initial value
 * @param newNumber The value that changed
 */
export const getPercentageChange = (oldNumber: number, newNumber: number): number => {
  return (newNumber - oldNumber) / oldNumber * 100;
};
